import { useRef } from "react";

import { TableSimpleStore } from "ds/components/TableSimple/types";
import TableWrapper from "ds/components/Table/Wrapper";
import Table from "ds/components/Table";
import TableSimpleHead from "ds/components/TableSimple/Head";
import TableSkeleton from "ds/components/Table/Skeleton";
import TableBody from "ds/components/Table/Body";
import { ConfigElement } from "types/generated";

import IntentProjectEnvironmentMountedFilesTableRows from "./Rows";

type IntentProjectEnvironmentMountedFilesTableProps = {
  data: ConfigElement[];
  store: TableSimpleStore;
  ariaLabel: string;
  loading?: boolean;
  itemIdKey?: string;
  wrapperClassName?: string;
};

const IntentProjectEnvironmentMountedFilesTable = ({
  data,
  store,
  ariaLabel,
  loading,
  itemIdKey = "id",
  wrapperClassName,
}: IntentProjectEnvironmentMountedFilesTableProps) => {
  const tableRef = useRef<HTMLDivElement>(null);
  const columnIds = store((state) => state.columnsOrder.visible);

  return (
    <TableWrapper ref={tableRef} hasPagination={false} className={wrapperClassName}>
      <Table ariaLabel={ariaLabel}>
        <TableSimpleHead store={store} ariaLabel={ariaLabel} tableRef={tableRef} />
        {loading && <TableSkeleton columnIds={columnIds} rowsPerPage={30} />}

        <TableBody>
          {!loading && (
            <IntentProjectEnvironmentMountedFilesTableRows
              data={data}
              store={store}
              tableRef={tableRef}
              itemIdKey={itemIdKey}
            />
          )}
        </TableBody>
      </Table>
    </TableWrapper>
  );
};

export default IntentProjectEnvironmentMountedFilesTable;
